export const FORM_VIEW_ID = {
  address: 1,
  pickup: 2,
  manager: 3,
}

export const KEY_CODES = {
  Enter: 13,
  Escape: 27,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
}

export const SETTLEMENTS_ID = {
  // Екатеринбург
  ekb: 27503892,
  // Москва
  msk: 1686293227,
  // Новосибирск
  nsib: 27503928,
}

/**
 * Идентификаторы групп доставки
 * @type {Object}
 */
export const DELIVERY_GROUPS = {
  pickup: 0,
  address: 1,
  car: 2,
  russianPost: 3,
  jpOrganizers: 4,
  simalandManagerAgreement: 5,
  other: 6,
}

/**
 * Идентификаторы групп адресных доставок.
 */
export const ADDRESS_DELIVERY_GROUPS_IDS = [
  DELIVERY_GROUPS.address,
  DELIVERY_GROUPS.russianPost,
]

/**
 * Состояния истории для HTML5 History API на странице оформления заказа
 * @type {Object}
 */
export const HISTORY_STATE_PAGES = {
  index: 1,
  modal: 2,
}

/**
 * Объект с данными путей до урла без base_url
 * @type {Object}
 */
export const API_END_POINT = {
  V3_CART_ITEM: 'v3/cart-item/',
  V4_DELIVERY_TYPE: 'v4/delivery-type/',
  V4_DELIVERY_TYPE_NEW: 'v4/delivery/type/',
  V4_ORDER_AGREEMENT: 'v4/order-agreement/',
  V3_JP_ORGANIZER: 'v3/jp-organizer/',
  V3_CART: 'v3/cart/',
  V3_ORDER_FORM: 'v3/order-form/',
  V3_ORDER: 'v3/order/',
  V4_ORDER_CONDITIONS: 'v4/order-conditions/',
}

/**
 * Объект с данными попапа товаров партнера.
 * @type {Object}
 */
export const DEFAULT_REMOTE_ITEMS_POPUP = {
  templates: {
    text: 'Товары со значком {item_flag} можно получить {tip}, даже если вы не набрали товаров на минимальную сумму заказа. Оставшиеся товары сохранятся в корзине.',
    order_title: 'Оформление заказа (только товары партнёров)',
  },
  title: 'Товары партнёров',
  buttonText: 'Заказать только товары партнёров',
  data: {
    item_flag: {
      type: 'badge',
      color: '#000',
      value: 'Товар партнёра',
    },
    tip: {
      type: 'tip',
      value: 'всеми способами, доступными в вашем регионе',
    },
  },
}

/**
 * Объект с данными баннера товаров партнера.
 * @type {Object}
 */
export const DEFAULT_REMOTE_ITEMS_BANNER = {
  templates: {
    bannerText: 'Товары партнёров можно {link} без дополнительных наценок и получить любым доступным способом.',
  },
  data: {
    link: {
      type: 'popup_link',
      value: 'заказать отдельно',
    },
  },
  queryParams: {
    [API_END_POINT.V3_CART]: {
      is_remote: 1,
    },
    [API_END_POINT.V3_CART_ITEM]: {
      group: 'remote',
    },
    [API_END_POINT.V4_DELIVERY_TYPE]: {
      remote_order: 1,
    },
    [API_END_POINT.V4_DELIVERY_TYPE_NEW]: {
      remote_order: 1,
    },
    [API_END_POINT.V3_JP_ORGANIZER]: {
      remote_order: 1,
    },
    [API_END_POINT.V4_ORDER_AGREEMENT]: {
      remote_order: 1,
    },
    [API_END_POINT.V3_ORDER_FORM]: {
      remote_order: 1,
    },
    [API_END_POINT.V3_ORDER]: {
      remote_order: 1,
    },
    [API_END_POINT.V4_ORDER_CONDITIONS]: {
      remote_order: 1,
    },
  },
}

/**
 * Идентификаторы неточности адреса дадаты.
 * @type {Array}
 */
export const QC_GEO_UNDEFINED = Object.values({
  street: '2',
  settlement: '3',
  city: '4',
  not_defined: '5',
})

/**
 * Наименования служб доставок.
 * @type {Object}
 */
export const COMPANY_NAMES = Object.freeze({
  simaland: 'simaland',
  ozon: 'ozon',
  dpd: 'dpd',
  boxberry: 'boxberry',
  cdek: 'cdek',
  five_post: 'five_post',
  russian_post: 'russian_post',
})

/**
 * Идентификаторы точности адреса дадаты.
 * @type {Array}
 */
export const QC_GEO_DEFINED = Object.values({
  exact: '0',
  house: '1',
})

/**
 * Количество отображаемых пунктов самовывоза.
 * @type {number}
 */
export const PICKUP_ITEMS = 10

/**
 * Идентификаторы неточности адреса яндекса.
 * @type {Array}
 */
export const YANDEX_GEO_DEFINED = Object.values({
  exact: 'exact',
  number: 'number',
})

/**
 * Стандартный индекс временного интервала отгрузки.
 * @type {string}
 */
export const DEFAULT_TIME_INTERVAL_INDEX = 'shouldSelectTime'

/**
 * Идентификаторы типов доставки.
 * @type {Object}
 */
export const DELIVERY_TYPES = {
  // Пункт выдачи заказа Сима-ленд
  simalandPoint: 1,
  // Доставка службой Сима-ленд
  simaland: 3,
  // Согласовать с менеджером
  simalandManagerAgreement: 5,
  // Доставка службой СПСР до двери
  spsr: 6,
  // Пункт выдачи СДЭК
  sdekPoint: 7,
  // Доставка службой СДЭК
  sdek: 8,
  // Доставка службой СПСР до пункта выдачи
  spsrPoint: 9,
  // Самовывоз со склада Екатеринбург
  simalandEkaterinburg: 10,
  // Самовывоз Москва
  simalandMoscow: 11,
  // Самовывоз из гипермаркета
  simalandHypermarket: 12,
  // Получение с машины
  simalandFromCar: 13,
  // Почта России до отделения
  russianPostPickup: 16,
  // boxberry доставка до двери
  boxberry: 17,
  // boxberry пункт самовывоза
  boxberryPoint: 18,
  // Пункт выдачи заказов на Радищева в Екатеринбурге
  simalandRadischeva: 19,
  // Самовывоз краснодар
  simalandKrasnodar: 20,
  // Доставка агентом (самовывоз)
  agentDeliveryPickup: 21,
  // Доставка агентом (адресная)
  agentDeliveryAddress: 22,
  // Авиадоставка службой Сима-ленд до пункта выдачи
  simalandAviaPickup: 23,
  // Авиадоставка службой Сима-ленд
  simalandAvia: 24,
  // Пункт выдачи заказов пер. Банковский в Екатеринбурге
  simalandBankovskiy: 25,
  // Пункт выдачи Ozon
  ozonPoint: 27,
  // Доставка другой транспортной службой
  customDelivery: 28,
  // Cо склада другой транспортной компании
  customPickup: 29,
  // ПВЗ в Петербурге
  sntPetersburgPickup: 30,
  // ПВЗ в Новосибирске
  novosibirskPickup: 31,
  // dpd до двери
  dpdToDoor: 32,
  // dpd пункт самовывоза
  dpdPoint: 33,
  // ПВЗ на ул. Родонитовая в Екатеринбурге
  simalandRodonitovaya: 34,
  // ПВЗ Магаданская обл, Магадан г, Марчеканский пер, в/г 16
  simalandMagadan: 35,
  // ПВЗ Камчатский край, Петропавловск-Камчатский г, Высотная ул, дом № 14, корпус 5
  simalandPetropavlovskKamchatsky: 36,
  // ПВЗ Сахалинская обл, Южно-Сахалинск г, Западная ул, дом № 58
  simalandYuzhnoSakhalinsk: 37,
  // ПВЗ ул. Токарей, д. 26 г. Екатеринбург
  simalandTokarey: 38,
  // Почта России до двери
  russianPostToDoor: 39,
  // ПВЗ партнёров
  partners: 41,
  // ПВЗ в г. Санкт-Петербург на ул. Гороховая
  simalandSpbGorohovaya: 42,
  // ПВЗ в г. Воронеж
  simalandVoronezh: 43,
  // ПВЗ в г. Санкт-Петербург на пр. Индустриальный
  simalandSpbIndustrial: 44,
  // ПВЗ почты России
  russianPostPoint: 46,
  // ПВЗ почты России ECOM
  russianPostPointEcom: 49,
  // ПВЗ в Екатеринбурге на ул. Анатолия Мехренцева
  simalandMehrenzeva: 50,
  // Постаматы PickPoint
  pickPoint: 51,
  // Постаматы 5Post
  fivePost: 52,
  // ПВЗ в Екатеринбурге на ул. Кузнецова
  simalandKuznecova: 53,
  // ПВЗ в Арамиле на ул. 1 Мая
  simalandAramil: 54,
  // ПВЗ в ТЦ "Кит"
  simalandKit: 55,
  // ПВЗ в Екатеринбурге на ул. Академика Бардина
  simalandBardina: 56,
  // ПВЗ в Екатеринбурге на ул. Малышева
  simalandMalysheva: 57,
  // ПВЗ в Нижнем Тагиле на ул. Газетная
  simalandTagil: 58,
  // г. Екатеринбург, ул. Восточная 11Б
  simalandVostochnaya: 59,
  // г. Екатеринбург, ул. Щорса 38/1
  simalandSchersa: 60,
  // г. Екатеринбург, ул. Соболева 19
  simalandSoboleva: 61,
  // г. Казань, ул. Восход 16
  simalandKazan: 62,
  // г. Уфа, ул. 50-летия Октября 30
  simalandUfa: 63,
  // г. Иркутск, ул. Розы Люксембург, 198 В/1
  simalandIrkutsk: 64,
  // г. Киров, Октябрьский проспект, д. 92
  simalandKirov: 65,
  // г. Челябинск, проспект Ленина, д. 74
  simalandChelyabinsk: 66,
  // г. Новосибирск, улица Челюскинцев, д. 7
  simalandNovosibirskCheluskintsev: 67,
  // г. Пермь, улица Ленина, д. 100
  simalandPermLenina: 68,
  // г. Тюмень, ул. 50 лет Октября, 37б/2
  simalandTumen50LenOctober: 69,
  // г. Нижний Новгород, пр. Гагарина, дом 5, пом. П1
  simalandNizhniiNovgorodGagarina: 70,
  // г. Новосибирск, ул. Сибиряков-Гвардейцев 1
  simalandNovosibirskSibiryakovGvardeitsev: 71,
  // г. Санкт-Петербург, Московский пр-т, 66 Лит. А, пом. 7Н
  simalandSpbMoscowAvenue: 72,
  // г. Екатеринбург, ул. Челюскинцев, дом 33
  simalandCheluskintsev: 73,
  // г. Екатеринбург, ул. Щербакова, дом 20
  simalandScherbakova: 74,
  // г. Екатеринбург, ул. Репина, 107
  simalandRepina: 75,
  // г. Анадырь, ул. Полярная, 1
  simalandAnadyr: 76,
}

/**
 * Список идентификаторов типов доставки Сима-ленд.
 * @type {Array}
 */
export const SIMALAND_DELIVERY_TYPES_IDS = [
  DELIVERY_TYPES.simaland,
  DELIVERY_TYPES.simalandEkaterinburg,
  DELIVERY_TYPES.simalandMoscow,
  DELIVERY_TYPES.simalandHypermarket,
  DELIVERY_TYPES.simalandFromCar,
  DELIVERY_TYPES.simalandKrasnodar,
  DELIVERY_TYPES.simalandRadischeva,
  DELIVERY_TYPES.simalandBankovskiy,
  DELIVERY_TYPES.simalandAviaPickup,
  DELIVERY_TYPES.simalandAvia,
  DELIVERY_TYPES.novosibirskPickup,
  DELIVERY_TYPES.sntPetersburgPickup,
  DELIVERY_TYPES.simalandRodonitovaya,
  DELIVERY_TYPES.simalandMagadan,
  DELIVERY_TYPES.simalandPetropavlovskKamchatsky,
  DELIVERY_TYPES.simalandYuzhnoSakhalinsk,
  DELIVERY_TYPES.simalandTokarey,
  DELIVERY_TYPES.simalandSpbGorohovaya,
  DELIVERY_TYPES.simalandVoronezh,
  DELIVERY_TYPES.simalandSpbIndustrial,
  DELIVERY_TYPES.simalandMehrenzeva,
  DELIVERY_TYPES.simalandKuznecova,
  DELIVERY_TYPES.simalandAramil,
  DELIVERY_TYPES.simalandKit,
  DELIVERY_TYPES.simalandBardina,
  DELIVERY_TYPES.simalandMalysheva,
  DELIVERY_TYPES.simalandTagil,
  DELIVERY_TYPES.simalandVostochnaya,
  DELIVERY_TYPES.simalandSchersa,
  DELIVERY_TYPES.simalandSoboleva,
  DELIVERY_TYPES.simalandKazan,
  DELIVERY_TYPES.simalandUfa,
  DELIVERY_TYPES.simalandIrkutsk,
  DELIVERY_TYPES.simalandKirov,
  DELIVERY_TYPES.simalandChelyabinsk,
  DELIVERY_TYPES.simalandNovosibirskCheluskintsev,
  DELIVERY_TYPES.simalandPermLenina,
  DELIVERY_TYPES.simalandTumen50LenOctober,
  DELIVERY_TYPES.simalandNizhniiNovgorodGagarina,
  DELIVERY_TYPES.simalandNovosibirskSibiryakovGvardeitsev,
  DELIVERY_TYPES.simalandSpbMoscowAvenue,
  DELIVERY_TYPES.partners,
]

/**
 * Список идентификаторов типов доставки почты России.
 * @type {Array}
 */
export const RUSSIAN_POST_DELIVERY_TYPES_IDS = [
  DELIVERY_TYPES.russianPostPoint,
  DELIVERY_TYPES.russianPostPointEcom,
  DELIVERY_TYPES.russianPostToDoor,
  DELIVERY_TYPES.russianPostPickup,
]

/**
 * Айди типов доставки самовывоза
 * @type {Array}
 */
export const PICKUP_DELIVERY_IDS = [
  // ПВЗ Сима-ленд со склада в Москве или Екатеринбурге, согласовывается с Менеджером
  1,
  // Согласовать с менеджером
  5,
  // Самовывоз со склада в Екатеринбурге Черняховского, 86, корп. 9 (52 ворота)
  10,
  // Самовывоз в г. Москва, городской округ Домодедово, село Ям (складской комплекс «КЕС Ям»)
  11,
  // ПВЗ Гипермаркет, ул. Черняховского, 86/13, 2 подъезд
  12,
  // Со склада другой тк в поселении
  14,
  // Почта России до двери
  15,
  // Почта России до отделения
  16,
  // ПВЗ boxberry
  18,
  // ПВЗ ТЦ "Ботаника Молл" - 5 дней
  19,
  // Самовывоз в г. Краснодар, ул. Московская, 111, 21 ворота
  20,
  // Самовывоз из пункта выдачи заказов представителя Сима-ленд
  21,
  // Самовывоз в г. Москва, городской округ Домодедово, село Ям (складской комплекс «КЕС Ям») авиадоставкой
  23,
  // ПВЗ переулок "Банковский" д.10 г.Екатеринбург
  25,
  //  Доставка другой транспортной службой
  28,
  // Со склада другой тк
  29,
  // ПВЗ Санкт-Петербург
  30,
  // Самовывоз со склада в Новосибирске
  31,
  // ПВЗ DPD
  33,
  // ПВЗ ул.Родонитовая д.27 г.Екатеринбург
  34,
  // ПВЗ Магаданская обл, Магадан г, Марчеканский пер, в/г 16
  35,
  // ПВЗ Камчатский край, Петропавловск-Камчатский г, Высотная ул, дом № 14, корпус 5
  36,
  // ПВЗ Сахалинская обл, Южно-Сахалинск г, Западная ул, дом № 58
  37,
  // ПВЗ ул. Токарей, д. 26 г. Екатеринбург
  38,
  // ПВЗ в г. Санкт-Петербург на ул. Гороховая
  42,
  // ПВЗ в г. Воронеж
  43,
  // ПВЗ в г. Санкт-Петербург на пр. Индустриальный
  44,
]

/**
 * Тип оплаты
 * @type {Object}
 */
export const PAYMENT_TYPES = {
  // Безналичный платёж по счёту
  cashless: 0,
  // Банковской картой Visa, MasterCard или «Мир» на сайте
  creditCardOnline: 1,
  // Оплата наличными
  cash: 2,
  // Банковской картой Visa или MasterCard при получении
  creditCardUponRecipient: 3,
  // Согласовать с менеджером
  agreeWithManager: 4,
  // В кредит
  onCredit: 5,
  // Оплата на кассе пункта выдачи заказов
  atTheCheckoutCounter: 6,
  // Оплата на кассе склада перед получением товара
  inTheWarehouseBeforeReceiving: 7,
  // Банковской картой Visa, MasterCard или «Мир» на сайте (быстрая оплата)
  creditCardOnlineMoment: 8,
  // ApplePay
  applePay: 9,
  // Наличными через транспортную компанию
  cacheTransportCompany: 10,
}

export const PICKUP_TYPES = {
  // Со склада в Екатеринбурге
  ekbPoint: 1,
  // Со склада в Москве
  moscowPoint: 2,
  // Из пункта выгрузки в г.
  cityPoint: 3,
  // Со склада транспортной компании в г.
  transportCompanyStorage: 4,
}

export const ORDER_TYPE_ID = {
  // Обычный заказ
  default: 1,

  // Заявка на совместную закупку
  jpRequest: 2,

  // Заказ организатора совместной закупки
  jpOrganizer: 3,

  // Удаленный заказ
  remote: 7,
}

/**
 * Статус покупателя
 * @type {Object}
 */
export const PERSON_TYPE = {
  // Физическое лицо
  customer: 1,

  // Юридическое лицо
  legalCompany: 2,

  // ИП
  legalPerson: 3,
}

/**
 * Типы сортировки
 * @type {Object}
 */
export const SORT_TYPES = {
  cheap: 'cost',
  expensive: '-cost',
  date: 'date',
}

/**
 * Наименование статуса покупателя
 * @type {Array}
 */
export const PERSON_TYPE_NAMES = {
  customer: 'Физ. лицо',
  legalEntity: 'Юр. лицо / ИП',
}

/**
 * Тип товара "Услуга"
 * @type {number}
 */
export const PRODUCT_SERVICE_TYPE = 2
/**
 * Атрибут товара, определяющий отображение цены за единицу вложения
 * @type {number}
 */
export const CUSTOM_QTY_UNITS_ATTR_ID = 2894

/**
 * Значения локали
 * @type {Object}
 */
export const LOCALES = {
  en: 'en-US',
  ru: 'ru-RU',
}
/**
 * Минимальные поддерживаемые версии браузеров
 * @type {Оbject}
 */
export const OLD_BROWSER_VERSIONS = {
  desktop: {
    msie: '11',
    firefox: '52',
    chrome: '59',
    safari: '7',
    opera: '45',
  },
  mobile: {
    firefox: '55',
    chrome: '61',
    safari: '6',
    opera: '44',
  },
  mobileIOS: {
    chrome: '61',
    safari: '6',
    opera: '11',
    firefox: '5',
    operamini: '11',
  },
  mobileAndroid: {
    chrome: '61',
    opera: '41',
    firefox: '55',
    operamini: '27',
    operamobile: '43',
  },
}
/**
 * Задержка перед загрузкой рекомендаций в поиске
 * @type {number}
 */
export const SEARCH_RECOMENDATIONS_LOAD_LATENCY = 1000

/**
 * Тип заказа
 * @type {Object}
 */
export const ORDER_TYPE = {
  guestOrder: 'guest-order',
  userOrder: 'user-order',
  JpOrder: 'jp-order',
  JpRequest: 'jp-request',
  serviceOrder: 'service-order',
}

/**
 * Действия менеджера.
 * @type {Object}
 */
export const MANAGER_ACTION = {
  // По-умолчанию
  default: 1,
  // Звонок не требуется
  withoutCall: 2,
  // Позвонить сейчас
  callNow: 3,
}

/**
 * Количество подсказок для Dadata.
 * @const
 * @type {Object}
 */
export const DADATA_HINTS_COUNTS = {
  default: 5,
  maximum: 20,
}

/**
 * Типы подсказок Dadata.
 * @const
 * @type {Object}
 */
export const DADATA_TYPES = {
  address: 'address',
  party: 'party',
}

/**
 * Типы ограничений Dadata.
 * @const
 * @type {Object}
 */
export const DADATA_BOUNDS = {
  address: 'address',
  street: 'street',
  house: 'house',
  party: 'party',
}

/**
 * Идентификаторы по типам организаций из данных Dadata для базы проекта.
 * @const
 * @type {Object}
 */
export const DADATA_PARTY_TYPES_IDS = {
  LEGAL: 2,
  INDIVIDUAL: 3,
}

/**
 * Статусы организаций Dadata.
 * @const
 * @type {Object}
 */
export const DADATA_PARTIES_STATUSES = {
  active: 'ACTIVE',
  liquidating: 'LIQUIDATING',
  liquidated: 'LIQUIDATED',
}

/**
 * Поля подсказок Dadata, необходимые для работы страницы оформления заказа.
 * @const
 * @type {string[]}
 */
export const DADATA_SUGGESTIONS_FIELDS = [
  // поля адресов
  'area_kladr_id',
  'block',
  'block_type_full',
  'city',
  'city_district',
  'city_district_with_type',
  'city_kladr_id',
  'city_with_type',
  'fias_id',
  'flat',
  'flat_type',
  'flat_type_full',
  'geo_lat',
  'geo_lon',
  'house',
  'house_fias_id',
  'house_kladr_id',
  'house_type',
  'house_type_full',
  'kladr_id',
  'postal_code',
  'qc_geo',
  'region_kladr_id',
  'settlement',
  'settlement_kladr_id',
  'settlement_type_full',
  'settlement_with_type',
  'street',
  'street_kladr_id',
  'street_type',
  'street_type_full',
  'street_with_type',

  // поля организаций
  'address',
  'inn',
  'kpp',
  'management',
  'name',
  'ogrn',
  'okved',
  'opf',
  'state',
  'type',
]

/**
 * Префикс ключа хранилища сессии для идентификатора выбранного товара в каталоге.
 * Выбранный товар - тот, на страницу которого перешли со страницы каталога.
 * @type {string}
 */
export const SESSION_CHOOSED_ITEM_ID_PREFIX = 'chosenCatalogItemId::'

/**
 * Состояния загружаемых данных.
 * @type {Object}
 */
export const DATA_STATES_TYPES = {
  initial: 'initial',
  fetching: 'fetching',
  success: 'success',
  error: 'error',
}

/**
 * Шаги формы выобора организатора СП на странице оформления заказа.
 * @type {Object}
 */
export const CHECKOUT_JP_FORM_STEPS = {
  list: 0,
  addressForm: 1,
  pickupList: 2,
  final: 3,
}

/**
 * Токен DaData
 * @type {string}
 */
export const DADATA_TOKEN = '456b824510e1ccf20fb23f1e5695179a9a38dab1'

/**
 * Поддерживаемые форматы дат для moment.js.
 * @type {Array<string>}
 */
export const SUPPORTED_DATE_FORMATS = [
  'DD.MM.YYYY',
  'YYYY-MM-DD',
  'DD.MM.YYYY HH:mm',
]

/**
 * Ключи фильтров по авто
 * @type {{year: string, vendor: string, model: string, modification: string}}
 */
export const FILTER_BY_CAR_KEYS = {
  vendor: 'car_vendor',
  model: 'car_model',
  year: 'car_year',
  modification: 'car_modification',
}

/**
 * Объект типов Vk событий
 * @type {Object.<string, string>}
 * home            - посещение главной страницы sima-land.ru;
 * category        – посещение страницы категорий каталога;
 * product         – посещение карточки товара;
 * search          – посещение страницы поиска;
 * other           – посещение любых других страниц, отличных от главной, категории, карточки, поиска;
 * addWishItem     – добавление товара в избранное;
 * addCartItem     – добавление товара в корзину;
 * removeWishItem  – удаление товара из избранного;
 * removeCartItem  – удаление товара из корзины;
 * checkoutStart   – начало покупки, страница оформления заказа /checkout/;
 * orderDone       - страница спасибо за заказ, /order/done
 */
export const VK_TARGETING_EVENT_TYPES = {
  home: 'view_home',
  category: 'view_category',
  search: 'view_search',
  other: 'view_other',
  addWishItem: 'add_to_wishlist',
  addCartItem: 'add_to_cart',
  removeWishItem: 'remove_from_wishlist',
  removeCartItem: 'remove_from_cart',
  checkoutStart: 'init_checkout',
  orderDone: 'purchase',
}

/**
 * Типы команд для cqc
 * @type {{
 *         showForm: string,
 *         cartUpdate: string
 *       }}
 */
export const CQC_COMMAND_TYPES = {
  cartUpdate: 'cart/UPDATE',
  showForm: 'settlement/SHOW_FORM',
  settlementUpdate: 'settlement/UPDATE',
  currencyUpdate: 'currency/UPDATE',
  showAuthForm: 'app/SHOW_AUTH_FORM',
  showRegistrationForm: 'app/SHOW_REGISTRATION_FORM',
  initApplicationConsultant: 'consultant/INIT_APPLICATION',
}

/**
 * Мапинг типов команд и Backbone событий.
 * @type {Object}
 */
export const CQC_COMMANDS_TYPES_TO_EVENTS = {
  'currency/UPDATE': 'update-currency',
  'settlement/UPDATE': 'update-settlement',
}

/**
 * Событие для отправки команды в cqc канал
 * @type {string}
 */
export const CQC_COMMAND_EVENT = 'cqc:command'

/**
 * Контекст cqc-команд для приложения на es6
 * @type {string}
 */
export const CQC_ES6_CONTEXT = 'backbone-es6-context'

/**
 * Категория для отправки событий клика в ОКО (свойство "category" для задачи SL-23315).
 * @type {string}
 */
export const CHECKOUT_OKO_CLICK_CATEGORY = 'checkout_click_element'

/**
 * Временное имя атрибута для прослушивания клика на странице заказа.
 * @type {string}
 */
export const CHECKOUT_CUSTOM_OKO_CLICK_ATTRIBUTE_NAME = 'data-temp-oko-event-click'

/**
 * Типы контрагентов.
 * @type {{}}
 */
export const COUNTERPARTY_TYPES = {
  individual: 1,
  entity: 2,
  mixed: 3,
  foreign: 4,
}

/**
 * Типы экранов ввода пин-кода.
 */
export const DEFAULT_PIN_CODE_SCREEN_TYPES = {
  smsScreen: 1,
  phoneScreen: 2,
  phoneNumberScreen: 3,
}

/**
 * Коды ошибок подтверждения заказа.
 * @type {Object.<string, integer>}
 * confirmNotAvailable - ошибка невозможности подтверждения пинкода;
 */
export const ORDER_CONFIRM_ERROR_CODES = Object.freeze({
  confirmNotAvailable: 426,
})

/**
 * Коды статусов счетов.
 * @type {Object.<string, integer>}
 * idRejectByOperator - Идентификатор отмены счёта оператором через 1С;
 * idRejectOnSite - Идентификатор отмены счёта через сайт;
 */
export const CHECK_CANCEL_STATUSES = Object.freeze({
  idRejectByOperator: 16,
  idRejectOnSite: 28,
})

/**
 * Имя Backbone события для смены id города в oko.info после изменения города.
 * @type {string}
 */
export const UPDATE_OKO_SETTLEMENT = 'update-oko-settlement'
